import React from 'react';
import { connect } from 'react-redux';
import {
  ChiTietDon,
  QuaTrinhXuLy,
  GiaiQuyetDonTruongPhong,
  GiaiQuyetDonCanBo,
  GiaiQuyetDonCanBoNhapLieu,
  NhapThongTinToTTXX,
  LapDuThaoCanBo,
  KetQuaGiaiQuyetDonTruongPhong,
  // KetQuaChuyenGiaoGiaiQuyetDonCanBo,
  KetQuaHoanThanhGiaiQuyetDonCanBo,
  KetQuaGiaiQuyetDonCanBoNhapLieu,
  KetQuaNhapThongTinToTTXM,
  KetQuaLapDuThaoCanBo,
  KetQuaXuLyDon,
  CanBoKiemTraDeXuat,
  KetQuaCanBoKiemTraDeXuat,
  TruongPhongNhanBaoCaoTTXM,
  LapDuThaoDonKhieuNaiCanBo,
  TruongPhongNhanYeuCauDoiThoai,
  CanBoGiaiQuyetYeuCauLapDuThao,
  // KetQuaLapDuThaoDonKhieuNaiCanBo,
  KetQuaCanBoGiaiQuyetYeuCauLapDuThao,
  KetQuaTruongPhongNhanBaoCaoTTXM,
  TruongPhongNhanBaoCaoTTXMDonKhieuNai,
  TruongPhongKiemTraDeXuat,
  CanBoNhanYeuCauTheoDoiThucHien,
  TruongPhongNhanYeuCauTheoDoiThucHien,
  KetQuaTheoDoiThucHien
} from './subView';
import {ContainerFileDinhKem} from 'components/upload';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import { ShowIf } from 'components/utils';
import { Link, browserHistory } from 'react-router';
import { GiaiQuyetDonThu, LetterProcessingWorkFlow, Letter, Reception } from 'api';
import {Text} from 'components/tt-forms/common';
import {ConfirmDialog} from 'modules/dialog';
import {MasterLayout} from 'layout';
import {Loading} from 'modules/loading';
import { CheckViewPermission } from 'modules/login/CheckPermission';
import { CheckQuyenThaoTacXuLy } from 'modules/login/CheckQuyenThaoTacXuLy.js';

class XuLyGiaiQuyetDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      pageLoading: false,
      id: this.props.params.id,
      type: this.props.params.type,
      status: '',
      isOpen: true,
      isSubmit: false,
      hideKetQuaXuLyDon: false,
      nameComponent: '',
      typeComponent: '',
      data: {
        listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM: []
      },
      dataLoaiNguoiDD: [],
      dataLoaiDonThu: [],
      dataLoaiDoiTuong: [],
      dataLichSuQuaTrinhXuLy: [],
      dataDonViTTXM: [],
      dsTepDinhKem: [],
      dataGiaiQuyetDon: [],
      coQuanQuanLyNguoiDung: [],
      dataNextStates: '',
      canBoXuLyChiDinh: '',
      yKienGiaiQuyet: '',
      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',
      ngayHetHanGiaiQuyet: '',
      dataLichSuGiaiQuyet: [],
      loaiDon: 'DON_KHIEU_NAI',
      dataKetQuaXuLyDon: {},
      donViGiaoTTXM: {},
      taiLieuDinhChi: {},
      listTaiLieuVanThuKiemTraDeXuat: [],
      dataKiemTraDeXuat: [],
      backConfirm: false,
      hasChange: false,
      hideQuaTrinhXuLy: false
    }
  }

  componentWillMount() {
    this.determinativeVaiTro();
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        coQuanQuanLyNguoiDung: {
          ...this.state.coQuanQuanLyNguoiDung,
          id: userInfo.coQuanQuanLyId,
          ten: userInfo.tenCoQuanQuanLy
        },
        donViGiaoTTXM: userInfo.donViId
      });
    }
  }

  componentDidMount() {
    if(this.state.type == 'giai-quyet') {
      this.setState({
        isOpen: false
      });
    }
    this.getDonDetail(this.state.id);
    this.getQuyTrinhXuLyHistory(this.state.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id != this.props.params.id) {
      this.getDonDetail(nextProps.params.id);
      this.getQuyTrinhXuLyHistory(nextProps.params.id);
    }
  }

  getTrangThaiDonHienTai(donId, processType) {
    Letter.actions.getTrangThaiDon.request({id: donId}, {quyTrinh: processType}).then(res => {
      if (res.data) {
        this.setState({status: res.data.trangThaiDon}, () => {
          this.getLichSuGiaiQuyetDon(this.state.id);
        });
      }
      this.setState({pageLoading: false});
    }).catch(e => {
      this.setState({status: 'DA_GIAI_QUYET'});
      this.getLichSuGiaiQuyetDon(this.state.id);
      this.setState({pageLoading: false});
    });
  }

  getDonDetail(inputId) {
    let params = {
      id: inputId
    }
    this.setState({pageLoading: true});
    Letter.actions.getDonDetail.request(params).then(res => {
      if (res.data) {
        let resData = res.data;
        if (resData.canBoDangXuLyInfo) {
          this.setState({
            canBoDangXuLyInfo: resData.canBoDangXuLyInfo || ''
          });
        }
        if (CheckViewPermission(res.data)) {
          Reception.actions.getDonInfo.request({ id: inputId }).then(res1 => {
            if (res1.data) {
              resData = {...resData, ...res1.data};
            }
            this.getTrangThaiDonHienTai(inputId, resData.processType);
            let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
            if (res.data.donViThamTraXacMinhInfo && res.data.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
              this.setState({
                hideKetQuaXuLyDon: true
              })
            }
            this.setState({
              data: resData,
              loaiDon: resData.loaiDon,
              dataKetQuaXuLyDon: {
                thamQuyenGiaiQuyet: resData.thamQuyenGiaiQuyetInfo ? resData.thamQuyenGiaiQuyetInfo.ten : ''
              }
            });
          });
        } else {
          browserHistory.push('/page-403');
        }
      }
    });
  }

  getQuyTrinhXuLyHistory(inputId) {
    LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: inputId }).then(res => {
      if(res.data._embedded) {
        this.setState({ dataLichSuQuaTrinhXuLy: res.data ? res.data._embedded.lichSuQuaTrinhXuLies : [] });
      }
    });
  }

  handleClick() {
    this.setState({isOpen: !this.state.isOpen});
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  getLichSuGiaiQuyetDon(id) {
    let params = {
      id: id
    }
    GiaiQuyetDonThu.actions.getLichSuGiaiQuyetDon.request(params).then(res => {
      this.state.dataKetQuaXuLyDon.yKienXuLy = res.data.thongTinGiaiQuyetDonInfo ? res.data.thongTinGiaiQuyetDonInfo.yKienXuLyDon : '';
      this.state.dataKetQuaXuLyDon.phongBanGiaiQuyet = res.data.phongBanGiaiQuyetInfo ? res.data.phongBanGiaiQuyetInfo.ten : '';
      this.setState({
        dataLichSuGiaiQuyet: res.data,
        dataKetQuaXuLyDon: this.state.dataKetQuaXuLyDon,
        dataKiemTraDeXuat: res.data.thongTinYeuCauKiemTraDeXuatInfo
      }, ()=> {
        if (this.state.status == 'DA_GIAI_QUYET') {
          this.setState({
            nameComponent: res.data.nextFormInfo ? res.data.nextFormInfo.alias : '',
            typeComponent: res.data.nextStateInfo ? res.data.nextStateInfo.type : ''
          });
        } else {
          this.getCurrentForm(this.state.id);
        }
      });
      if (this.state.status == 'DA_GIAI_QUYET') {
        this.checkHideKetQuaXuLyDon()
      }
    });
  }

  getCurrentForm(id) {
    let params = {
      donId: id
    }
    LetterProcessingWorkFlow.actions.getCurrentForm.request(params).then(res => {
      if (this.state.data.laTTXMLai) {
        res.data.listNextStates = res.data.listNextStates.filter(item => {
          return item.type != 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN'
        });
      }
      this.setState({
        nameComponent: res.data.currentForm.alias,
        dataNextStates: res.data.listNextStates
      });
      this.checkHideKetQuaXuLyDon();
    });

  }

  checkAllowHandle() {
    let pass = CheckQuyenThaoTacXuLy(this.state.canBoDangXuLyInfo);
    return pass;
  }

  renderWorkFollow() {
    let allowHandle = this.checkAllowHandle();
    if (this.state.data.trangThaiDonInfo && this.state.data.trangThaiDonInfo[0].ketQuaType != 'DINH_CHI') {
      switch (this.state.nameComponent) {
        case 'TruongPhongGiaiQuyetDonAction':
          if (!allowHandle || this.state.status === 'DA_GIAI_QUYET') {
            let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
            let trangThaiDonInfo = this.state.data && this.state.data.trangThaiDonInfo && this.state.data.trangThaiDonInfo[0];
            if (trangThaiDonInfo.donViId === userInfo.donViId && (trangThaiDonInfo.ketQuaType === "LUU_HO_SO" || trangThaiDonInfo.ketQuaType === "DANG_TDTH" || trangThaiDonInfo.ketQuaType === "GIAO_TDTH")) {
              let listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView = this.state.data && this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView;
              let thongTinGiaiQuyetDonInfo = this.state.dataLichSuGiaiQuyet && this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo;
              return (
                <KetQuaTheoDoiThucHien
                  listTaiLieuVanThuGiaiQuyetDon={listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
                  {...thongTinGiaiQuyetDonInfo}
                  loaiDon={this.state.loaiDon}
                  donInfo={this.state.data}
                  thongTinGQD={thongTinGiaiQuyetDonInfo}
                  handleBack={this.handleBack.bind(this)}
                  listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                  thongTinYeuCauKiemTraDeXuat={this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
                />
                )
              }
            return (
              <KetQuaGiaiQuyetDonTruongPhong
              roleGQ = {'truongPhongGiaiQuyetDon'}
              id={this.state.id}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              coQuanQuanLyNguoiDung = {this.state.coQuanQuanLyNguoiDung}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonView}
              dataLichSuGiaiQuyet = {this.state.dataLichSuGiaiQuyet}
              dataKetQuaXuLyDon={this.state.dataKetQuaXuLyDon}
              handleBack = {this.handleBack.bind(this)}
              />
            )
          } else {
            return (
              <GiaiQuyetDonTruongPhong
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              roleGQ = {'truongPhongGiaiQuyetDon'}
              id={this.state.id}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDon}
              listTaiLieuVanThuGiaiQuyetDonView={this.state.data.listTaiLieuVanThuGiaiQuyetDonView}
              listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
              listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
              listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
              listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
              dataNextStates={this.state.dataNextStates}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              loaiDon={this.state.loaiDon}
              />
            )
          }

        case 'TruongPhongNhanDuThaoVaGiaoViec':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaLapDuThaoCanBo
              nhanDuThao={true}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              handleBack = {this.handleBack.bind(this)}
              loaiDon={this.state.loaiDon}
            />
            )
          } else {
            return (
              <TruongPhongNhanBaoCaoTTXMDonKhieuNai
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              roleGQ = {'truongPhongGiaiQuyetDon'}
              id={this.state.id}
              nhanDuThao={true}
              truongPhongThuHoi={this.props.truongPhongThuHoi}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              dataNextStates={this.state.dataNextStates}
              coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
              listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
              listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
              listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
              isTTXMLai = {this.state.data.laTTXMLai}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              loaiDon={this.state.loaiDon}
              />
            )
          }
        case 'TruongPhongNhanBaoCaoTTXMVaGiaoViec':
          if (!allowHandle || this.state.status === 'DA_GIAI_QUYET') {
            if ((this.state.dataLichSuGiaiQuyet && this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo && (this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) ||
              this.state.typeComponent === 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO'
            ) {
              return (
                <KetQuaLapDuThaoCanBo
                  listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                  listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  donInfo={this.state.data}
                  thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  handleBack = {this.handleBack.bind(this)}
                  loaiDon={this.state.loaiDon}
                />
              );
            } else {
              return (
                <KetQuaTruongPhongNhanBaoCaoTTXM
                  {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  phongBanGiaiQuyetChiDinhInfo={this.state.dataLichSuGiaiQuyet.phongBanGiaiQuyetChiDinhInfo}
                  phongBanGiaiQuyetInfo={this.state.dataLichSuGiaiQuyet.phongBanGiaiQuyetInfo}
                  listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  yKienGiaoPhongBan={this.state.dataLichSuGiaiQuyet.yKienGiaiQuyet}
                  donInfo={this.state.data}
                  thongTinGQD={this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  handleBack={this.handleBack.bind(this)}
                  loaiDon={this.state.loaiDon}
                />
              );
            }
          } else {
            if (this.state.loaiDon === 'DON_KHIEU_NAI' || this.state.loaiDon === "DON_TRANH_CHAP_DAT") {
              return (
                <TruongPhongNhanBaoCaoTTXMDonKhieuNai
                  handleChangeData={this.handleChangeData.bind(this)}
                  handleBack={this.handleBack.bind(this)}
                  roleGQ={'truongPhongBanTiepCongDan'}
                  id={this.state.id}
                  thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
                  dataNextStates={this.state.dataNextStates}
                  truongPhongThuHoi={this.props.truongPhongThuHoi}
                  coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
                  listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                  donInfo={this.state.data}
                  thongTinGQD={this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  isTTXMLai={this.state.data.laTTXMLai}
                  updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
                  postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
                  saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
                  loaiDon={this.state.loaiDon}
                />
              );
            } else {
              return (
                <TruongPhongNhanBaoCaoTTXM
                  handleChangeData={this.handleChangeData.bind(this)}
                  handleBack={this.handleBack.bind(this)}
                  roleGQ='truongPhongGiaiQuyetDon'
                  truongPhongThuHoi={this.props.truongPhongThuHoi}
                  id={this.state.id}
                  thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
                  dataNextStates={this.state.dataNextStates}
                  coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
                  listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                  donInfo={this.state.data}
                  thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                  isTTXMLai = {this.state.data.laTTXMLai}
                  updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
                  postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
                  saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
                  loaiDon={this.state.loaiDon}
                />
              );
            }
          }
        case 'TruongPhongNhanBaoCaoTTXMLaiVaGiaoViec':
          if (this.state.status == 'DA_GIAI_QUYET') {
            // if (this.state.typeComponent != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO') {
              if ((this.state.dataLichSuGiaiQuyet && this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo && (this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) ||
                this.state.typeComponent === 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO'
              ) {
                // if (this.state.loaiDon == 'DON_KHIEU_NAI') {
                //   return (
                //     <KetQuaLapDuThaoDonKhieuNaiCanBo
                //     listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                //     listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                //     {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                //     handleBack = {this.handleBack.bind(this)}
                //     donInfo={this.state.data}
                //     thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                //     loaiDon={this.state.loaiDon}
                //     />
                //   )
                // } else {
                  return (
                    <KetQuaLapDuThaoCanBo
                    listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                    listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                    donInfo={this.state.data}
                    thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                    {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                    handleBack = {this.handleBack.bind(this)}
                    loaiDon={this.state.loaiDon}
                    />
                  )
                // }

              } else {
                return (
                  <KetQuaTruongPhongNhanBaoCaoTTXM
                  {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  phongBanGiaiQuyetChiDinhInfo={this.state.dataLichSuGiaiQuyet.phongBanGiaiQuyetChiDinhInfo}
                  phongBanGiaiQuyetInfo={this.state.dataLichSuGiaiQuyet.phongBanGiaiQuyetInfo}
                  listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  yKienGiaoPhongBan={this.state.dataLichSuGiaiQuyet.yKienGiaiQuyet}
                  donInfo={this.state.data}
                  thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  handleBack = {this.handleBack.bind(this)}
                  loaiDon={this.state.loaiDon}
                  />
                )
              }
            // } else {
            //   return(
            //     <KetQuaLapDuThaoDonKhieuNaiCanBo
            //       listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
            //       {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            //       loaiDon={this.state.loaiDon}
            //       donInfo={this.state.data}
            //       thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            //       handleBack = {this.handleBack.bind(this)}
            //     />
            //   )
            // }
          } else {
            if (this.state.loaiDon == 'DON_KHIEU_NAI') {
              return(
                <TruongPhongNhanBaoCaoTTXMDonKhieuNai
                  handleChangeData = {this.handleChangeData.bind(this)}
                  handleBack = {this.handleBack.bind(this)}
                  roleGQ = {'truongPhongGiaiQuyetDon'}
                  id={this.state.id}
                  thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
                  dataNextStates={this.state.dataNextStates}
                  truongPhongThuHoi={this.props.truongPhongThuHoi}
                  coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
                  listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                  donInfo={this.state.data}
                  thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  isTTXMLai = {this.state.data.laTTXMLai}
                  updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
                  postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
                  saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
                  loaiDon={this.state.loaiDon}
                />
              )
            } else {
              return (
                <TruongPhongNhanBaoCaoTTXM
                handleChangeData = {this.handleChangeData.bind(this)}
                handleBack = {this.handleBack.bind(this)}
                roleGQ = {'truongPhongGiaiQuyetDon'}
                truongPhongThuHoi={this.props.truongPhongThuHoi}
                id={this.state.id}
                thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
                dataNextStates={this.state.dataNextStates}
                coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
                listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                donInfo={this.state.data}
                thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                isTTXMLai = {this.state.data.laTTXMLai}
                updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
                postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
                saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
                loaiDon={this.state.loaiDon}
                />
              )
            }
          }
        case 'CanBoGiaiQuyetDonAction':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return(
              <KetQuaHoanThanhGiaiQuyetDonCanBo
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              handleBack = {this.handleBack.bind(this)}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonView}
              loaiDon={this.state.loaiDon}/>
            )
          } else {
            return (
              <GiaiQuyetDonCanBo
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              id={this.state.id}
              dataGiaiQuyet = {this.state.dataLichSuGiaiQuyet}
              postTaiLieuVanThu = {this.postTaiLieuVanThu.bind(this)}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDon}
              listTaiLieuVanThuGiaiQuyetDonView={this.state.data.listTaiLieuVanThuGiaiQuyetDonView}
              listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
              listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
              listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
              listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
              dataNextStates={this.state.dataNextStates}
              coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              loaiDon={this.state.loaiDon}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              noiDungDonThu={this.state.data.noiDung}
              listNguoiDungDon={this.state.data.listNguoiDungDon}
              coQuanDangQuyetInfo={this.state.data.coQuanDangQuyetInfo}
              donViGiaoTTXM={this.state.donViGiaoTTXM}/>
            )
          }
        case 'CanBoGiaiQuyetDonKhongQuyTrinh':
          if (this.state.status == 'DA_GIAI_QUYET') {
              return(
                <KetQuaHoanThanhGiaiQuyetDonCanBo
                {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                handleBack = {this.handleBack.bind(this)}
                donInfo={this.state.data}
                thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonView}
                loaiDon={this.state.loaiDon}/>
              )
          } else {
            return (
              <GiaiQuyetDonCanBo
                handleChangeData = {this.handleChangeData.bind(this)}
                handleBack = {this.handleBack.bind(this)}
                id={this.state.id}
                dataGiaiQuyet = {this.state.dataLichSuGiaiQuyet}
                postTaiLieuVanThu = {this.postTaiLieuVanThu.bind(this)}
                thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
                listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDon}
                listTaiLieuVanThuGiaiQuyetDonView={this.state.data.listTaiLieuVanThuGiaiQuyetDonView}
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                dataNextStates={this.state.dataNextStates}
                nameComponent={this.state.nameComponent}
                coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
                updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
                saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
                loaiDon={this.state.loaiDon}
                donInfo={this.state.data}
                noRule = {true}
                thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                noiDungDonThu={this.state.data.noiDung}
                listNguoiDungDon={this.state.data.listNguoiDungDon}
                coQuanDangQuyetInfo={this.state.data.coQuanDangQuyetInfo}
                donViGiaoTTXM={this.state.donViGiaoTTXM}/>
            )
          }
        case 'CanBoNhapLieuGiaiQuyetDonAction':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaGiaiQuyetDonCanBoNhapLieu
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              yKienGiaiQuyet={this.state.dataLichSuGiaiQuyet.yKienGiaiQuyet}
              loaiDon={this.state.loaiDon}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              handleBack = {this.handleBack.bind(this)}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDon}/>
            )
          } else {
            return (
              <GiaiQuyetDonCanBoNhapLieu
                handleChangeData = {this.handleChangeData.bind(this)}
                handleBack = {this.handleBack.bind(this)}
                id={this.state.id}
                donInfo={this.state.data}
                thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
                dataNextStates={this.state.dataNextStates}
                listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDon}
                postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
              />
            )
          }
        case 'LanhDaoTTXMAction':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaGiaiQuyetDonTruongPhong
              roleGQ = {'truongPhongTTXM'}
              id={this.state.id}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              handleBack = {this.handleBack.bind(this)}
              coQuanQuanLyNguoiDung = {this.state.coQuanQuanLyNguoiDung}
              listTaiLieuVanThu = {this.state.data.listTaiLieuVanThu}
              dataLichSuGiaiQuyet = {this.state.dataLichSuGiaiQuyet}
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              loaiDon={this.state.loaiDon}
              />
            )
          }
        break;
        case 'TruongPhongTTXMAction':
          if (!allowHandle || this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaGiaiQuyetDonTruongPhong
              roleGQ = {'truongPhongTTXM'}
              id={this.state.id}
              handleBack = {this.handleBack.bind(this)}
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              coQuanQuanLyNguoiDung = {this.state.coQuanQuanLyNguoiDung}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuGiaiQuyetDon = {this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              dataLichSuGiaiQuyet = {this.state.dataLichSuGiaiQuyet}
              loaiDon={this.state.loaiDon}
              />
            )
          } else {
            return (
              <GiaiQuyetDonTruongPhong
              alias={this.state.nameComponent}
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              truongPhongThuHoi={this.props.truongPhongThuHoi}
              roleGQ = {'truongPhongTTXM'}
              id={this.state.id}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              dataNextStates={this.state.dataNextStates}
              coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
              postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              loaiDon={this.state.loaiDon}
              />
            )
          }
        case 'CanBoTTXMAction':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaNhapThongTinToTTXM
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              handleBack = {this.handleBack.bind(this)}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              loaiDon={this.state.loaiDon}
              />
            )
          } else {
            return (
              <NhapThongTinToTTXX
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              id={this.state.id}
              dataNextStates={this.state.dataNextStates}
              postTaiLieuVanThu = {this.postTaiLieuVanThu.bind(this)}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              loaiDon={this.state.loaiDon}/>
            )
          }
        case 'CanBoTTXMKhongQuyTrinh':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaNhapThongTinToTTXM
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              handleBack = {this.handleBack.bind(this)}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              loaiDon={this.state.loaiDon}
              />
            )
          } else {
            return (
              <NhapThongTinToTTXX
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              id={this.state.id}
              dataNextStates={this.state.dataNextStates}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              postTaiLieuVanThu = {this.postTaiLieuVanThu.bind(this)}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              loaiDon={this.state.loaiDon}/>
            )
          }

        case 'CanBoTTXMChuyenDuThaoKhongQuyTrinh':
        case 'CanBoTTXMChuyenDuThaoAction':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaCanBoGiaiQuyetYeuCauLapDuThao
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              handleBack = {this.handleBack.bind(this)}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
              loaiDon={this.state.loaiDon}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              />
            )
          } else {
            return (
              <CanBoGiaiQuyetYeuCauLapDuThao
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              id={this.state.id}
              coQuanQuanLyNguoiDung = {this.state.coQuanQuanLyNguoiDung}
              dataNextStates={this.state.dataNextStates}
              postTaiLieuVanThu = {this.postTaiLieuVanThu.bind(this)}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
              listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
              listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
              listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}

              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              loaiDon={this.state.loaiDon}/>
            )
          }
        case 'TruongPhongTTXMNhanYeuCauVaGiaoViecAction':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaCanBoGiaiQuyetYeuCauLapDuThao
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              handleBack = {this.handleBack.bind(this)}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
              loaiDon={this.state.loaiDon}
              />
            )
          } else {
            return (
              <TruongPhongNhanYeuCauDoiThoai
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              id={this.state.id}
              truongPhongThuHoi={this.props.truongPhongThuHoi}
              coQuanQuanLyNguoiDung = {this.state.coQuanQuanLyNguoiDung}
              dataNextStates={this.state.dataNextStates}
              postTaiLieuVanThu = {this.postTaiLieuVanThu.bind(this)}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}

              listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
              listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
              listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
              listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              loaiDon={this.state.loaiDon}/>
            )
          }
        case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh':
        case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoAction':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaLapDuThaoCanBo
              listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
              handleBack = {this.handleBack.bind(this)}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              nhanDuThao={true}
              loaiDon={this.state.loaiDon}
              />
            )
          } else{
            return (
              <LapDuThaoDonKhieuNaiCanBo
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              id={this.state.id}
              nhanDuThao={true}
              dataNextStates={this.state.dataNextStates}
              postTaiLieuVanThu = {this.postTaiLieuVanThu.bind(this)}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
              listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
              listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
              listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              loaiDon={this.state.loaiDon}/>
            )
          }

        case 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh':
        case 'CanBoGiaiQuyetDonLapDuThaoAction':
          if (this.state.status == 'DA_GIAI_QUYET') {
            // if (this.state.loaiDon == 'DON_KHIEU_NAI') {
            //   return (
            //     <KetQuaLapDuThaoDonKhieuNaiCanBo
            //       listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
            //       handleBack = {this.handleBack.bind(this)}
            //       donInfo={this.state.data}
            //       thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            //       listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
            //       {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            //       loaiDon={this.state.loaiDon}
            //     />
            //   )
            // } else {
              return (
                <KetQuaLapDuThaoCanBo
                  listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                  handleBack = {this.handleBack.bind(this)}
                  donInfo={this.state.data}
                  thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  loaiDon={this.state.loaiDon}
                />
              )
            // }
          } else if (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon === "DON_TRANH_CHAP_DAT") {
            return (
              <LapDuThaoDonKhieuNaiCanBo
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              id={this.state.id}
              dataNextStates={this.state.dataNextStates}
              postTaiLieuVanThu = {this.postTaiLieuVanThu.bind(this)}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
              listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
              listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
              listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
              isTTXMLai={this.state.data.laTTXMLai}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              loaiDon={this.state.loaiDon}/>
            )
          } else {
            return (
              <LapDuThaoCanBo
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              id={this.state.id}
              dataNextStates={this.state.dataNextStates}
              postTaiLieuVanThu = {this.postTaiLieuVanThu.bind(this)}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
              listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
              listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
              listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
              isTTXMLai={this.state.data.laTTXMLai}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              loaiDon={this.state.loaiDon}/>
            )
          }
        case 'truongPhongKiemTraDeXuat':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaGiaiQuyetDonTruongPhong
              roleGQ = {'truongPhongKiemTraDeXuat'}
              id={this.state.id}
              handleBack = {this.handleBack.bind(this)}
              loaiDon={this.state.loaiDon}
              coQuanQuanLyNguoiDung = {this.state.coQuanQuanLyNguoiDung}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuKiemTraDeXuat}
              dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              dataLichSuGiaiQuyet = {this.state.dataLichSuGiaiQuyet}
              dataKetQuaXuLyDon={this.state.dataKetQuaXuLyDon}
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              />
            )
          } else {
            return (
              <TruongPhongKiemTraDeXuat
              handleChangeData = {this.handleChangeData.bind(this)}
              handleBack = {this.handleBack.bind(this)}
              roleGQ = {'truongPhongKiemTraDeXuat'}
              id={this.state.id}
              truongPhongThuHoi={this.props.truongPhongThuHoi}
              thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuKiemTraDeXuat}
              dataNextStates={this.state.dataNextStates}
              dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
              donInfo={this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
              updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
              postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
              saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
              loaiDon={this.state.loaiDon}
              />
            )
          }
        case 'canBoKiemTraDeXuatKhongQuyTrinh':
          if (this.state.status == 'DA_GIAI_QUYET') {
              return (
                <KetQuaCanBoKiemTraDeXuat
                  loaiDon={this.state.loaiDon}
                  handleBack = {this.handleBack.bind(this)}
                  listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuKiemTraDeXuat}
                  dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
                  donInfo={this.state.data}
                  thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                  thongTinYeuCauKiemTraDeXuat = {this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
                />
              )
            } else {
              return (
                <CanBoKiemTraDeXuat
                khongQuyTrinh={true}
                handleChangeData = {this.handleChangeData.bind(this)}
                handleBack = {this.handleBack.bind(this)}
                id={this.state.id}
                thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
                listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuKiemTraDeXuat}
                dataNextStates={this.state.dataNextStates}
                donInfo={this.state.data}
                thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
                coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
                postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
                saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
                loaiDon={this.state.loaiDon}
                />
              )
            }
        case 'canBoTDTHKhongQuyTrinh':
        case 'CanBoTDTHAction':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaTheoDoiThucHien
                listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
                loaiDon={this.state.loaiDon}
                donInfo={this.state.data}
                thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                handleBack = {this.handleBack.bind(this)}
                {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                thongTinYeuCauKiemTraDeXuat = {this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
              />
            )
          } else {
            return (
              <CanBoNhanYeuCauTheoDoiThucHien
                handleChangeData = {this.handleChangeData.bind(this)}
                thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
                handleBack = {this.handleBack.bind(this)}
                dataNextStates={this.state.dataNextStates}
                listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                id={this.state.id}
                donInfo={this.state.data}
                thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
                postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
                saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
                dataDetail= {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                loaiDon={this.state.loaiDon}
              />
            )
          }
        case 'TruongPhongTDTHAction':
          if (!allowHandle || this.state.status === 'DA_GIAI_QUYET') {
              return (
                <KetQuaTheoDoiThucHien
                  listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
                  {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  loaiDon={this.state.loaiDon}
                  donInfo={this.state.data}
                  thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  handleBack = {this.handleBack.bind(this)}
                  listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                  thongTinYeuCauKiemTraDeXuat = {this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
                />
              )
            } else {
              return (
                <TruongPhongNhanYeuCauTheoDoiThucHien
                  handleChangeData = {this.handleChangeData.bind(this)}
                  thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
                  handleBack = {this.handleBack.bind(this)}
                  truongPhongThuHoi={this.props.truongPhongThuHoi}
                  coQuanQuanLyNguoiDung = {this.state.coQuanQuanLyNguoiDung}
                  dataNextStates={this.state.dataNextStates}
                  updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
                  postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
                  saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
                  listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  id={this.state.id}
                  donInfo={this.state.data}
                  thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  dataDetail= {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  loaiDon={this.state.loaiDon}
                />
              )
            }
        case 'canBoKiemTraDeXuat':
          if (this.state.status == 'DA_GIAI_QUYET') {
            return (
              <KetQuaCanBoKiemTraDeXuat
                loaiDon={this.state.loaiDon}
                listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuKiemTraDeXuat}
                dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
                handleBack = {this.handleBack.bind(this)}
                donInfo={this.state.data}
                thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                thongTinYeuCauKiemTraDeXuat = {this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
              />
            )
          } else {
            return (
              <CanBoKiemTraDeXuat
                handleChangeData = {this.handleChangeData.bind(this)}
                handleBack = {this.handleBack.bind(this)}
                id={this.state.id}
                donInfo={this.state.data}
                thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
                listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuKiemTraDeXuat}
                dataNextStates={this.state.dataNextStates}
                dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
                coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
                postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
                saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
                loaiDon={this.state.loaiDon}
              />
            )
          }
        default:
          return (
          <div className="row pl15 pr15 wrap-block">
            <div className="wrap-big-line pt5 pb20">
              <span className="big-border"></span>
            </div>
            <div className="box-bottom col-100">
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            </div>
          </div>
        )
      }
    } else {
      return (
        <div className="row pl15 pr15 wrap-block">
          <div className="wrap-big-line pt5 pb20">
            <span className="big-border"></span>
          </div>
          <h2 className="title-14 mb15">Thông tin đã giải quyết</h2>
          <div className="txt-bold text-13 mb15 txt-upper">Đình chỉ</div>
          <div className="row pl10 pr10 mb10">
            <Text className="col-100 mb5" label="Lý do đình chỉ:" value={this.state.data.lyDoDinhChi}/>
            <div className="col-100 pb5">
              <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.state.data.listTaiLieuVanThu} disableAttachFile={true}/>
            </div>
          </div>
          <div className="mb20"><div className="line-border"></div></div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
          </div>
        </div>
      )
    }
  }

  checkHideKetQuaXuLyDon() {
    if ( this.state.nameComponent == 'canBoKiemTraDeXuat' || this.state.nameComponent == 'canBoKiemTraDeXuatKhongQuyTrinh' || this.state.nameComponent == 'truongPhongKiemTraDeXuat') {
      this.setState({
        hideKetQuaXuLyDon: true
      })
    }
    if (this.state.nameComponent == 'canBoKiemTraDeXuatKhongQuyTrinh') {
      this.setState({
        hideQuaTrinhXuLy: true
      })
    }
    this.setState({
      formGiaiQuyet : this.renderWorkFollow()
    })
  }

  updateGiaiQuyetDon(params, _params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.data.thongTinGiaiQuyetDonId},params).then(res => {
      this.postGiaiQuyetDon(_params, message);
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  saveGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.data.thongTinGiaiQuyetDonId},params).then(res => {
      this.onClickClose();
      Toastr(message ? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  onClickClose() {
    if (this.props.route.name == 'theodoi') {
      browserHistory.push('/theo-doi-thuc-hien-giai-quyet-don');
    } else if (this.props.route.name == 'dagiaiquyet') {
      browserHistory.push('/don-da-giai-quyet');
    } else {
      browserHistory.push('/giai-quyet-don');
    }
    this.props.dispatch({
      type: 'REFRESH_MENU',
      value: true
    });
  }

  postGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(res => {
      this.onClickClose();
      Toastr(message ? msg[message] : msg.giaiQuyetDon, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({...this.state});
  }

  handleBack(allowBack) {
    if (allowBack) {
      this.onClickClose();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({...this.state});
      } else {
        this.onClickClose();
      }
    }
  }

  handleChangeData() {
    this.setState({
      hasChange: true
    })
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
      <div>
        {
          this.state.pageLoading ?
            <Loading/>
          : ''
        }
        <div className={`center ${this.state.pageLoading ? 'hidden' :''}`}>
          <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
            title={msg.confirmBack} />
          <div className="back-foward">
            <Link onClick={ this.handleBack.bind(this, false) } title="">Về trang trước</Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-detail">Thông tin giải quyết đơn/vụ việc</h2>
          </div>

          <div className="page-wrapper">
            <ChiTietDon listTLBC={this.props.listTLBC} isOpen={this.state.isOpen} donId={this.state.id} loaiDon={this.state.loaiDon} dataGiaiQuyet={this.state.dataLichSuGiaiQuyet} data={this.state.data}/>
            <ShowIf condition={this.state.hideQuaTrinhXuLy != true}>
              <QuaTrinhXuLy parents={this}/>
            </ShowIf>
          </div>
          {
            !this.state.hideKetQuaXuLyDon ?
              <div className="page-wrapper">
                  <KetQuaXuLyDon donInfo={this.state.data} status={this.state.hideKetQuaXuLyDon} {...this.state.dataKetQuaXuLyDon} dataGiaiQuyet={this.state.dataLichSuGiaiQuyet}/>
              </div>
            :null
          }
          <div className="page-wrapper mb30">
            {this.renderWorkFollow()}
          </div>
        </div>
      </div>
      </MasterLayout>
    );
  }
}

export default connect()(XuLyGiaiQuyetDon);



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/XuLyGiaiQuyetDon.jsx